export default function Intro({ data: { chapter } }) {
  return (
    <div className="intro">
      <h1 className="">{chapter}</h1>
    </div>
  );
}
